import React from 'react';
import { Button } from './Button';
export function ProductShowcase() {
  const pillars = [{
    num: '1',
    title: 'Contexto primero',
    desc: 'Situación real antes de mostrar código. Los chicos no odian programar, odian no entender para qué sirve.'
  }, {
    num: '2',
    title: 'Anti-IA por diseño',
    desc: 'Ejercicios con contexto personal que ChatGPT no puede resolver con un mensaje genérico.'
  }, {
    num: '3',
    title: 'Sin baches',
    desc: 'Progresión exacta para que ningún alumno quede atrás.'
  }];
  const tomos = [{
    icon: '📘',
    num: '1',
    title: 'Fundamentos',
    desc: 'Variables, lógica y primer programa real. Donde el alumno que "nunca va a entender" escribe código y dice "¿eso era?"'
  }, {
    icon: '📗',
    num: '2',
    title: 'Estructuras de Decisión',
    desc: 'if, elif, else con ejemplos de videojuegos y sistemas reales. Donde ven lógica, no solo código.'
  }, {
    icon: '📙',
    num: '3',
    title: 'Estructuras Repetitivas',
    desc: 'for, while con simuladores y juegos. El tomo donde entienden para qué sirve programar.'
  }, {
    icon: '📕',
    num: '4',
    title: 'Funciones y Modularidad',
    desc: 'Código profesional desde el aula. Aprenden a resolver problemas, no a copiar soluciones.'
  }, {
    icon: '📓',
    num: '5',
    title: 'Estructuras de Datos',
    desc: 'Listas, diccionarios y conjuntos con ejemplos de inventarios y sistemas reales.'
  }, {
    icon: '📔',
    num: '6',
    title: 'Proyectos Aplicados',
    desc: '5 proyectos completos. Donde tus alumnos sienten que son programadores.'
  }];
  return <section className="py-6 md:py-8 px-4 bg-brand-cardAlt border-y border-white/5" data-id="element-143">
      <div className="max-w-2xl mx-auto" data-id="element-144">
        {/* Method intro */}
        <div className="text-center mb-6" data-id="element-145">
          <div className="inline-block bg-brand-accent/10 border border-brand-accent/30 rounded-full px-4 py-1.5 mb-3" data-id="element-146">
            <p className="text-brand-accent font-bold text-[10px] md:text-xs uppercase tracking-wider" data-id="element-147">
              ✨ EL MÉTODO
            </p>
          </div>
          <h2 className="text-xl md:text-3xl font-extrabold text-white mb-2 leading-tight" data-id="element-148">
            El "
            <span className="text-brand-accent" data-id="element-149">Método Progresión Real</span>"
          </h2>
          <p className="text-sm md:text-base text-gray-400 leading-relaxed" data-id="element-150">
            Un sistema construido por docentes de técnica para docentes de
            técnica. Bajamos la complejidad del código al lenguaje de tus
            alumnos, respetando la realidad de nuestras escuelas y los tiempos
            del aula.
          </p>
        </div>

        {/* 3 Pillars */}
        <div className="space-y-3 mb-8" data-id="element-151">
          {pillars.map((pillar, i) => <div key={i} className="bg-brand-card rounded-2xl border border-white/10 p-4 flex items-start gap-3" data-id="element-152">
              <div className="bg-brand-accent text-brand-dark font-extrabold text-lg rounded-xl w-10 h-10 flex items-center justify-center shrink-0" data-id="element-153">
                {pillar.num}
              </div>
              <div className="flex-1" data-id="element-154">
                <h3 className="font-bold text-white text-sm md:text-base mb-0.5" data-id="element-155">
                  {pillar.title}
                </h3>
                <p className="text-xs md:text-sm text-gray-400 leading-relaxed" data-id="element-156">
                  {pillar.desc}
                </p>
              </div>
            </div>)}
        </div>

        {/* 6 tomos header */}
        <div className="text-center mb-4" data-id="element-157">
          <h2 className="text-xl md:text-2xl font-extrabold text-white uppercase tracking-tight" data-id="element-158">
            Los 6 Tomos
          </h2>
        </div>

        <div className="space-y-2.5 mb-6" data-id="element-159">
          {tomos.map((tomo, i) => <div key={i} className="bg-brand-card border border-white/10 rounded-2xl p-4 hover:border-brand-accent/30 transition-colors" data-id="element-160">
              <div className="flex items-start gap-3" data-id="element-161">
                <span className="text-2xl shrink-0" data-id="element-162">{tomo.icon}</span>
                <div className="flex-1 min-w-0" data-id="element-163">
                  <h4 className="text-sm md:text-base font-bold text-white leading-tight mb-1" data-id="element-164">
                    Tomo {tomo.num} —{' '}
                    <span className="text-brand-accent" data-id="element-165">{tomo.title}</span>
                  </h4>
                  <p className="text-xs md:text-sm text-gray-400 leading-relaxed" data-id="element-166">
                    {tomo.desc}
                  </p>
                </div>
              </div>
            </div>)}
        </div>

        <div className="w-full max-w-sm mx-auto text-center" data-id="element-167">
          <Button className="text-sm md:text-base py-3.5 w-full" data-id="element-168">
            🚀 → QUIERO LOS 6 TOMOS AHORA
          </Button>
        </div>
      </div>
    </section>;
}